import { Injectable } from '@angular/core';
import { LocalStorageService } from 'angular-web-storage';
import { AnalyticsService } from './analytics/analytics.service';
//import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CurrencyService {

  CURRENCY_KEY = 'currency';
  EUR='EUR';
  //execChange: Subject<string> = new Subject<string>();

  constructor(
    private local: LocalStorageService,
    private analyticsService: AnalyticsService
  ) { }

  setCurrency(currency: string) {
    this.local.set(this.CURRENCY_KEY,currency);
    let data = {'event' : 'changeCurrency', 'Webapp':'Spectrum'};
    this.analyticsService.pushEventData(data);
    //this.execChange.next(currency);
  }

  // removeCurrency() {
  //   this.local.remove(this.CURRENCY_KEY);
  // }

  getCurrency():string {
    let selectedCurrency= this.local.get(this.CURRENCY_KEY);
    if(!selectedCurrency){
      selectedCurrency=this.EUR;
      this.setCurrency(selectedCurrency);
    }
    return selectedCurrency;
  }

  isEuro(){
    return this.getCurrency() === this.EUR;
  }

  // clearCurrency() {
  //   this.local.clear();
  // }
}
